import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.sidebar/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class LayoutSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.status.toggle('navbar', true);
    }

    public async closeSidebar() {
        await this.service.status.toggle('navbar', true);
    }
}

export default LayoutSidebarComponent;